import { useContext, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { GlobalContext } from '../../context/Context';
import { useFormik } from 'formik';
import * as yup from "yup";
import moment from 'moment';
import { File, UploadCloud } from 'lucide-react';
import InnerLoader from '../ui/loader/inner-loader';
import { Link } from 'react-router';
import Select from "react-select";

const AssignCarModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, carId }) => {

  let { state } = useContext(GlobalContext);

  const apiCall = useApiCall();

  const [authorityError , setAuthorityError] = useState(false);

  const validationSchema = yup.object({
    employee: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    allotmentDate: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    maintenanceKm: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    maintenanceDate: yup
      .string('This Field is Required')
      .required('This Field is Required'),
  });

  const formik = useFormik({
    initialValues: {
      employee: '',
      allotmentDate: '',
      maintenanceKm: '',
      maintenanceDate: '',
      authority: '',
      authorityLoader: false
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let data = {
        "car_id": carId,
        "assigned_to_employee": values?.employee,
        "allotment_date": moment(values?.allotmentDate).format("DD-MM-YYYY"),
        "next_maintenance_km": values?.maintenanceKm,
        "next_maintenance_date": moment(values?.maintenanceDate).format("DD-MM-YYYY"),
        "autthority_letter": values?.authority
      }

      try {
        let apiRes = await apiCall({ method: "post", url: "assign-car-to-user", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  const handleFileUpload = async (file) => {
    let apiData = new FormData();
    apiData.append('file', file);
    setAuthorityError(false);
    formik.setFieldValue("authority", "");
    formik.setFieldValue("authorityLoader", true);
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
      formik.setFieldValue("authority", apiRes?.path?.filepath);
      formik.setFieldValue("authorityLoader", false)
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head} !bg-white !block`}>
          <div className="flex items-center justify-between">
            <h4> Assign Car </h4>
            <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Employee</label>
                  {/* <select name='employee' value={formik.values.employee} onChange={formik.handleChange}>
                    <option value="">-- Select Employee --</option>
                    {employees?.map((eachEmployee, i) => (
                      <option value={eachEmployee?.id} key={i}>{eachEmployee?.name}</option>
                    ))}
                  </select> */}
                  <Select
                    placeholder={` -- Select Employee -- `}
                    value={
                      formik.values.employee ? state?.getDropdowns?.activeEmployeeList?.map((ele) => ({label: ele?.emp_name, value: ele?.emp_id}))?.find((opt) => opt.value === formik.values.employee) : null
                    }
                    onChange={(selected) => {
                      formik.setFieldValue("employee", selected?.value)
                    }}
                    options={state?.getDropdowns?.activeEmployeeList?.map((ele) => ({label: ele?.emp_name, value: ele?.emp_id}))}
                    className="w-full h-12"
                    components={{
                      IndicatorSeparator: () => null, // 🚀 removes separator
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        height: "48px",
                        minHeight: "48px",
                        borderRadius: "0.375rem", // rounded-md
                        borderColor: "#d1d5db", // blue-500 or gray-300
                        boxShadow: "none", // focus:ring-2 ring-blue-500
                        "&:hover": {
                          borderColor: "#9ca3af", // gray-400
                        },
                        fontSize: "14px", // text-xs
                        paddingLeft: "0.5rem", // px-2
                        paddingRight: "0.5rem",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "48px",
                        padding: "0 0.25rem",
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: "0px 0px 20px",
                        width: "14px",
                        height: "14px",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        fontSize: "14px",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#374151", // text-gray-700
                      }),
                      placeholder: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#9ca3af", // text-gray-400
                      }),
                      menu: (base) => ({
                        ...base,
                        marginTop: "2px",
                        borderRadius: "0.375rem",
                        border: "1px solid #e5e7eb", // gray-200
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        zIndex: 50,
                      }),
                      indicatorContainer: (base) => ({
                        ...base,
                        padding: '0px'
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "14px",
                        padding: "0.5rem 0.75rem",
                        cursor: "pointer",
                        backgroundColor: state.isSelected
                          ? "#3b82f6"
                          : state.isFocused
                            ? "#f3f4f6"
                            : "white",
                        color: state.isSelected ? "white" : "#374151", // text-gray-700
                      }),
                    }}
                  />
                  {/* { } */}
                  {
                    (formik.touched.employee && Boolean(formik.errors.employee)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.employee && formik.errors.employee}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Allotment Date</label>
                    <input
                      type="date"
                      name='allotmentDate'
                      min={1}
                      value={formik.values.allotmentDate}
                      onChange={formik.handleChange}
                      placeholder='Allotment Date'
                    />
                    {
                      (formik.touched.allotmentDate && Boolean(formik.errors.allotmentDate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.allotmentDate && formik.errors.allotmentDate}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Next Maintenance (Km)</label>
                    <input
                      type="text"
                      name='maintenanceKm'
                      min={1}
                      value={formik.values.maintenanceKm}
                      onChange={formik.handleChange}
                      placeholder='Maintenance in Km'
                    />
                    {
                      (formik.touched.maintenanceKm && Boolean(formik.errors.maintenanceKm)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.maintenanceKm && formik.errors.maintenanceKm}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Next Maintenance Date</label>
                    <input
                      type="date"
                      name='maintenanceDate'
                      min={1}
                      value={formik.values.maintenanceDate}
                      onChange={formik.handleChange}
                      placeholder='Maintenance Date'
                    />
                    {
                      (formik.touched.maintenanceDate && Boolean(formik.errors.maintenanceDate)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.maintenanceDate && formik.errors.maintenanceDate}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Authority Letter</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0]) }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.authorityLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0]) }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.authority ?
                      <div className="">
                        <Link to={formik.values?.authority} target='_blank' className='inline-block'>
                          {authorityError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.authority} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setAuthorityError(true);
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.authority && Boolean(formik.errors.authority)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.authority && formik.errors.authority}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default AssignCarModal